<template>&nbsp;</template>
<script lang="ts" setup>
definePage({
  redirect: {
    name: '/organizations/[organizationId]/organization/users/active/',
  },
})
</script>
